var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 18C1.875 9.09743 9.09743 1.875 18 1.875C26.9026 1.875 34.125 9.09743 34.125 18C34.125 26.9026 26.9026 34.125 18 34.125C9.09743 34.125 1.875 26.9026 1.875 18ZM18 4.125C10.3401 4.125 4.125 10.3401 4.125 18C4.125 25.6599 10.3401 31.875 18 31.875C25.6599 31.875 31.875 25.6599 31.875 18C31.875 10.3401 25.6599 4.125 18 4.125Z",
    fill: "#416873"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7045 12.7045C13.1438 12.2652 13.8562 12.2652 14.2955 12.7045L18 16.409L21.7045 12.7045C22.1438 12.2652 22.8562 12.2652 23.2955 12.7045C23.7348 13.1438 23.7348 13.8562 23.2955 14.2955L19.591 18L23.2955 21.7045C23.7348 22.1438 23.7348 22.8562 23.2955 23.2955C22.8562 23.7348 22.1438 23.7348 21.7045 23.2955L18 19.591L14.2955 23.2955C13.8562 23.7348 13.1438 23.7348 12.7045 23.2955C12.2652 22.8562 12.2652 22.1438 12.7045 21.7045L16.409 18L12.7045 14.2955C12.2652 13.8562 12.2652 13.1438 12.7045 12.7045Z",
    fill: "#416873"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.2ed40db47f8838810545c2a959533b25.svg";
export { ForwardRef as ReactComponent };